/* ====================================================================================================================
 * CHERİE — Kemer AOV kampanyası / şerit görünürlüğü
 * --------------------------------------------------------------------------------------------------------------------
 * Sorumluluğu tek şey: kemer seçim şeridi ne zaman açık, ne zaman kapalı olacağına karar vermek.
 * Sepete ekleme ve yeniden render Prestige'in kendi kodudur; burada tekrar edilmez.
 *
 * KURALLAR
 *   1. Şerit sunucudan `hidden` gelir. Bu oturumda kapatılmadıysa JS onu açar.
 *      (Sunucudan açık gelseydi, "Şimdi değil" dedikten sonra her sepet yenilemesinde geri gelirdi.)
 *   2. "Şimdi değil" yalnız o modu (`bag` / `gift`) kapatır. Sepet sonradan hediye eşiğini
 *      geçerse `gift` ayrı bir mod olduğu için şerit bir kez daha açılır — bu istenen davranıştır.
 *   3. Şerit kapalıyken yerinde "Kemer teklifini göster" satırı kalır. Kemer henüz sepette
 *      olmadığı için üstte bar da yoktur; geri dönüş yolu budur.
 *   4. Kampanya kemeri sepete eklenince şerit render edilmez, yerine bar gelir — JS'e iş düşmez.
 * ================================================================================================================== */

(() => {
  const DISMISSED_KEY = 'cherie-belt:dismissed-modes';

  const readDismissed = () => {
    try {
      return new Set(JSON.parse(sessionStorage.getItem(DISMISSED_KEY) || '[]'));
    } catch {
      return new Set();
    }
  };

  const writeDismissed = (set) => {
    try {
      sessionStorage.setItem(DISMISSED_KEY, JSON.stringify([...set]));
    } catch {
      /* gizli sekme — davranış bozulmasın, sadece hafıza kaybolur */
    }
  };

  /** Şerit ile onun kapalı hâlini tek karardan, birbirini dışlayacak biçimde günceller. */
  const applyVisibility = (picker, visible) => {
    picker.hidden = !visible;

    const reopenRow = document.querySelector(`[data-belt-reopen-row][data-belt-target="${picker.id}"]`);
    if (reopenRow) reopenRow.hidden = visible;
  };

  /** Sayfadaki her şerit için oturum hafızasına göre doğru görünürlüğü uygular. */
  const syncAll = () => {
    const dismissed = readDismissed();

    document.querySelectorAll('[data-belt-picker]').forEach((picker) => {
      applyVisibility(picker, !dismissed.has(picker.dataset.beltMode));
    });
  };

  /* ------------------------------------------------------------------------------------------------------------
   * Olay bağlantıları — tıklamalar delege edilir, çünkü sepet çekmecesi sürekli yeniden render edilir.
   * ---------------------------------------------------------------------------------------------------------- */

  document.addEventListener('click', (event) => {
    // "Şimdi değil" → bu modu bu oturum için kapat.
    const dismissButton = event.target.closest('[data-belt-dismiss]');
    if (dismissButton) {
      const picker = dismissButton.closest('[data-belt-picker]');
      if (!picker) return;

      const dismissed = readDismissed();
      dismissed.add(picker.dataset.beltMode);
      writeDismissed(dismissed);
      applyVisibility(picker, false);
      return;
    }

    // "Kemer teklifini göster" → kapatılmış şeridi geri getir ve görünür alana kaydır.
    const reopenButton = event.target.closest('[data-belt-reopen]');
    if (reopenButton) {
      const row = reopenButton.closest('[data-belt-reopen-row]');
      const picker = row && document.getElementById(row.dataset.beltTarget);
      if (!picker) return;

      const dismissed = readDismissed();
      dismissed.delete(picker.dataset.beltMode);
      writeDismissed(dismissed);
      applyVisibility(picker, true);
      picker.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
    }
  });

  // Sepet çekmecesi her yeniden render edildiğinde şerit yeni HTML ile gelir; kararı tekrar uygula.
  document.documentElement.addEventListener('cart-drawer:refreshed', syncAll);

  // Sepet sayfası ve ilk yükleme.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();

/* ====================================================================================================================
 * CHERİE — Kartlık hediyesi / sepete otomatik ekleme
 * --------------------------------------------------------------------------------------------------------------------
 * Liquid, hediye barının üstüne tek kelimelik bir talimat yazar: data-kartlik-action = add | remove | ok
 *   add     Eşik aşıldı, kartlık sepette yok           → sepete 1 adet ekle (property: _cherie_gift=kartlik)
 *   remove  Eşik düştü, bizim eklediğimiz kartlık duruyor → satırı sil
 *   ok      Yapılacak bir şey yok
 *
 * KORUMALAR
 *   1. Aynı anda tek istek; sepet yenilenince Liquid yeni talimatı yazar, döngü sunucudan kesilir.
 *   2. Müşteri hediyeyi kendi çıkardıysa (eşik hâlâ doluyken kartlık kaybolduysa) bu oturumda
 *      bir daha eklenmez. Eşiğin altına inip yeniden çıkması hakkı sıfırlar.
 *   3. Sepet SAYFASINDA çekmece yoktur; işlem bitince sayfa yenilenir (Prestige'in kendi davranışı).
 * ================================================================================================================== */

(() => {
  const DECLINED_KEY = 'cherie-gift:kartlik-declined';
  const LAST_KEY = 'cherie-gift:kartlik-last';
  let busy = false;
  // Sepet sayfasında reload() çağrılınca sayfa ANINDA gitmez; akış devam eder ve bir sonraki
  // sync() eski DOM'daki 'add' talimatını tekrar okuyup hediyeyi İKİNCİ kez ekler. Bu bayrak,
  // yenileme başladıktan sonra her turu kapatır.
  let reloading = false;

  const store = {
    get: (k) => { try { return sessionStorage.getItem(k); } catch { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch { /* gizli sekme */ } },
    del: (k) => { try { sessionStorage.removeItem(k); } catch { /* gizli sekme */ } },
  };

  const root = () => Shopify?.routes?.root || '/';

  /** Prestige'in ürün formuyla aynı yol: bundle edilecek section'ları topla, sepeti çek, cart:change yay. */
  const refreshCart = async (sectionsJson, context) => {
    if (context === 'page') {
      reloading = true;
      window.location.reload();
      return;
    }
    const cart = await (await fetch(`${root()}cart.js`)).json();
    cart.sections = sectionsJson || {};
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'cherie:gift', cart },
    }));
  };

  const bundledSections = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections },
    }));
    return sections.join(',');
  };

  const addGift = async (bar) => {
    const currentResponse = await fetch(`${root()}cart.js`);
    if (!currentResponse.ok) return false;
    const current = await currentResponse.json();
    if (current.items.some(item => item.variant_id === Number(bar.dataset.kartlikVariant))) return false;
    const response = await fetch(`${root()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: Number(bar.dataset.kartlikVariant), quantity: 1, properties: { _cherie_gift: 'kartlik' } }],
        sections: bundledSections(),
      }),
    });
    if (!response.ok) return false;
    const json = await response.json();
    await refreshCart(json.sections, bar.dataset.context);
    return true;
  };

  const reconcileGift = async (bar, keepOne) => {
    const currentResponse = await fetch(`${root()}cart.js`);
    if (!currentResponse.ok) return false;
    const current = await currentResponse.json();
    const lines = current.items.filter(item => item.variant_id === Number(bar.dataset.kartlikVariant));
    const updates = {};
    lines.forEach((line, index) => { updates[line.key] = keepOne && index === 0 ? 1 : 0; });
    if (lines.length === 0) return false;
    const response = await fetch(`${root()}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates, sections: bundledSections() }),
    });
    if (!response.ok) return false;
    const json = await response.json();
    await refreshCart(json.sections, bar.dataset.context);
    return true;
  };

  const sync = async () => {
    if (busy || reloading) return;
    // Sepet SAYFASINDA iki bar vardır (sayfa + gizli çekmece); sayfanınki esastır, işlem sonrası sayfa yenilenir.
    const bar = document.querySelector('[data-gift-bar][data-context="page"]') || document.querySelector('[data-gift-bar]');
    if (!bar) return;

    const unlocked = bar.dataset.kartlikUnlocked === 'true';
    const inCart = bar.dataset.kartlikInCart === 'true';
    const last = store.get(LAST_KEY); // "unlocked:inCart" — bir önceki render

    // Müşteri hediyeyi kendisi çıkardı mı? Önceki render'da "dolu + sepette", şimdi "dolu + yok".
    if (last === 'true:true' && unlocked && !inCart) store.set(DECLINED_KEY, '1');
    // Eşiğin altına inildi: vazgeçme hakkı sıfırlanır.
    if (!unlocked) store.del(DECLINED_KEY);
    store.set(LAST_KEY, `${unlocked}:${inCart}`);

    const action = bar.dataset.kartlikAction;
    if (action === 'add' && store.get(DECLINED_KEY)) return;
    if (!['add', 'remove', 'normalize'].includes(action)) return;

    busy = true;
    let changed = false;
    try {
      if (action === 'add') changed = await addGift(bar);
      else changed = await reconcileGift(bar, action === 'normalize');
    } catch (error) {
      console.warn('Chérie gift cart update failed', error);
    } finally {
      busy = false;
    }
    // Sayfa yenileniyorsa DOM hâlâ eski talimatı taşır; tekrar bakmak çift eklemeye yol açar.
    if (reloading) return;
    // Çekmece, istek sürerken yeniden render edildi ve o sırada gelen 'refreshed' olayı atlandı;
    // yeni duruma göre son bir kez daha bak (bu turda talimat 'ok' olur, yeni istek çıkmaz).
    if (changed && !bar.isConnected) sync();
  };

  document.documentElement.addEventListener('cart-drawer:refreshed', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();

/* ====================================================================================================================
 * CHERİE — Kutlama: bir hediye durağı geçildiğinde bir kez, dekupe görsel büyüyerek.
 * --------------------------------------------------------------------------------------------------------------------
 *   • Kartlık: eşik dolu VE kartlık sepette (otomatik ekleme bittikten sonra) → "Tebrikler, kartlığı kazandınız!"
 *              Alt satır: kemere kalan tutar; kemer de doluysa "aşağıdan seçin".
 *   • Kemer:   eşik dolu → "Tebrikler, kemer hediyeniz açıldı!" — ikisi aynı anda açılırsa kemer gösterilir.
 *   Her hediye oturumda bir kez kutlanır; eşiğin altına inilirse hak yenilenir.
 * ================================================================================================================== */

(() => {
  const KEY = (gift) => `cherie-gift:celebrated-${gift}`;
  const SHOW_MS = 5000;
  let hideTimer = null;

  const store = {
    get: (k) => { try { return sessionStorage.getItem(k); } catch { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch { /* gizli sekme */ } },
    del: (k) => { try { sessionStorage.removeItem(k); } catch { /* gizli sekme */ } },
  };

  const hide = (panel) => {
    if (!panel || panel.hidden) return;
    panel.classList.add('is-leaving');
    setTimeout(() => {
      panel.hidden = true;
      panel.classList.remove('is-leaving');
      panel.closest('[data-gift-bar]')?.classList.remove('is-celebrating');
    }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 200);
  };

  const show = (bar, { image, title, sub }) => {
    const panel = bar.querySelector('[data-celebrate]');
    if (!panel) return;
    const img = panel.querySelector('[data-celebrate-image]');
    img.src = image || '';
    img.hidden = !image;
    panel.querySelector('[data-celebrate-title]').textContent = title;
    panel.querySelector('[data-celebrate-sub]').textContent = sub;
    panel.classList.remove('is-leaving');
    panel.hidden = false;
    bar.classList.add('is-celebrating');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => hide(panel), SHOW_MS);
  };

  const check = () => {
    // Çekmece açıksa oradaki bar, değilse sayfadaki: görünür olanı kutla.
    // offsetParent çekmece içinde (fixed + shadow DOM) null döner; görünürlüğü kutu ölçüsüyle anla.
    const bar = document.querySelector('cart-drawer[open] [data-gift-bar]') || document.querySelector('[data-gift-bar][data-context="page"]');
    if (!bar) return;
    const d = bar.dataset;

    const kartlikEnabled = d.kartlikEnabled === 'true';
    const kartlikReady = kartlikEnabled && d.kartlikUnlocked === 'true' && d.kartlikInCart === 'true';
    const beltReady = d.beltUnlocked === 'true';

    if (kartlikEnabled && d.kartlikUnlocked !== 'true') store.del(KEY('kartlik'));
    if (!beltReady) store.del(KEY('belt'));

    if (beltReady && !store.get(KEY('belt'))) {
      store.set(KEY('belt'), '1');
      if (kartlikReady) store.set(KEY('kartlik'), '1');
      show(bar, {
        image: d.beltImage,
        title: d.celebrateBelt,
        sub: d.beltInCart === 'true' ? d.celebrateBeltAdded : d.celebrateBeltChoose,
      });
      return;
    }

    if (kartlikReady && !store.get(KEY('kartlik'))) {
      store.set(KEY('kartlik'), '1');
      show(bar, {
        image: d.kartlikImage,
        title: d.celebrateCardholder,
        sub: d.kartlikColorNote,
      });
    }
  };

  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-celebrate-close]');
    if (close) hide(close.closest('[data-celebrate]'));
  });

  document.documentElement.addEventListener('cart-drawer:refreshed', check);
  // Prestige bu olayı çekmecenin kendisinde, kabarcıklanmadan yayar; capture ile yakalanır.
  document.addEventListener('dialog:after-show', check, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();

(() => {
  const previous = new Map();
  const seen = new WeakSet();
  const animateProgress = () => {
    document.querySelectorAll('[data-gift-bar]').forEach(bar => {
      if (seen.has(bar)) return;
      seen.add(bar);
      const meter = bar.querySelector('.gift-bar__track');
      if (!meter) return;
      const target = Math.max(0, Math.min(100, Number(bar.dataset.progress) || 0));
      const context = bar.dataset.context;
      const start = previous.has(context) ? previous.get(context) : target;
      previous.set(context, target);
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || start === target) return;
      meter.style.setProperty('--gift-progress', `${start}%`);
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (bar.isConnected) meter.style.setProperty('--gift-progress', `${target}%`);
      }));
    });
  };
  document.documentElement.addEventListener('cart-drawer:refreshed', animateProgress);
  document.addEventListener('dialog:after-show', animateProgress, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', animateProgress);
  else animateProgress();
})();
